import { Link, useLocation } from 'react-router-dom'
import { useOrg } from '../org'
import { SETTINGS_TABS, activeSettingsTab } from '../layout/nav'
import { MapSettings } from './MapSettings'
import { ProfileSettings } from './ProfileSettings'
import { OrgMembers } from './OrgMembers'
import { OrgSetting } from './OrgSetting'
import { SavedViews } from './SavedViews'
import { useT } from '../i18n'

export function SettingsPage() {
  const { activeOrg } = useOrg()
  // Имя `tr`, а не `t`: ниже `t` — это элемент SETTINGS_TABS в map().
  const tr = useT()
  const { pathname } = useLocation()
  const tab = activeSettingsTab(pathname)

  return (
    <div className="mx-auto h-full max-w-3xl overflow-y-auto p-6">
      <h1 className="mb-5 text-xl font-semibold tracking-tight text-foam">{tr('settings.title')}</h1>
      <div className="mb-6 flex gap-1 border-b border-hull">
        {SETTINGS_TABS.map(t => (
          <Link
            key={t.id}
            to={t.path}
            replace
            className={[
              'px-4 py-2 text-sm transition-colors',
              tab === t.id
                ? 'border-b-2 border-sonar font-medium text-sonar'
                : 'text-mist hover:text-foam',
            ].join(' ')}
          >
            {tr(t.labelKey)}
          </Link>
        ))}
      </div>

      {tab === 'profile' && <ProfileSettings />}
      {tab === 'map' && <MapSettings />}
      {tab === 'org' && (
        <div className="space-y-4">
          <OrgSetting />
          <div className="text-sm text-mist">
            {tr('settings.org.line', { name: activeOrg?.name ?? '—' })}{' '}
            <span className="tnum text-sonar">{activeOrg?.role ?? '—'}</span>
          </div>
          <OrgMembers />
        </div>
      )}
      {tab === 'views' && <SavedViews />}
    </div>
  )
}
